import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export interface PaymentPlan {
    "@id": string;
    id: string;
    name: string;
    description: string;
    stripePriceId: string;
    stripeProductId: string;
    priceInCents: number;
    currency: string;
    billingInterval: "month" | "year";
    permissions: string[];
    isActive: boolean;
    sortOrder: number;
}

type UsePaymentPlansOptions = {
    isPaymentFeatureEnabled?: boolean;
};

export const usePaymentPlans = (options?: UsePaymentPlansOptions) => {
    const isPaymentFeatureEnabled = options?.isPaymentFeatureEnabled ?? false;
    const canFetchPaymentPlans = isPaymentFeatureEnabled;

    return useQuery<PaymentPlan[]>(
        ["payment-plans"],
        async () => {
            const response = await loggedInApiCall.get("/api/payment/payment_plans?isActive=true&order[sortOrder]=asc");

            return response.data["hydra:member"] || [];
        },
        {
            enabled: canFetchPaymentPlans,
            staleTime: 300000, // 5 minutes
            retry: 1,
        },
    );
};
